export const PAYMENT_OPTION_NAMES = {
  PAY_NOW: 'Pay now',
  PAY_MONTHLY: 'Pay monthly',
  PAY_BY_INVOICE: 'Pay by invoice',
} as const;

export const PAYMENT_OPTION_TRACKING_NAMES: Record<
  keyof typeof PAYMENT_OPTION_NAMES,
  string
> = {
  PAY_NOW: 'stripe_single_payment',
  PAY_MONTHLY: 'stripe_payment_plan',
  PAY_BY_INVOICE: 'invoice',
} as const;

export const PAYMENT_OPTION_TYPES = {
  "Pay now": 'stripe_single_payment',
  "Pay monthly": "stripe_payment_plan",
  "Pay by invoice": "invoice",
} as const;

export const PAY_MONTHLY_MIN_DAY_WINDOW = 32;
export const PAY_MONTHLY_PAYMENT_FORM_MIN_DAY_WINDOW = 60;
export const PAY_BY_INVOICE_MIN_DAY_WINDOW = 14;

export const MINIMUM_DEPOSIT_PERCENTAGE = 10;
export const MAXIMUM_DEPOSIT_PERCENTAGE = 50;
